import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CandidateClauseService} from '@core/ecv-http-services/services/candidate-clause.service';


@Component({
  selector: 'app-accept-clause',
  templateUrl: './accept-clause.component.html',
  styleUrls: ['./accept-clause.component.scss']
})
export class AcceptClauseComponent implements OnInit {
  token: string;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private candidateClauseService: CandidateClauseService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.token = params['token'];
      this.candidateClauseService.sendAcceptClause(this.token).subscribe(reposnse => {
      });
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/candidate-clause/accept-clause.component.ts